import { AES, enc } from "crypto-ts";
// @ts-ignore
import VueJwtDecode from "vue-jwt-decode";
import { LoginResponseDTO } from "@/api/auth/LoginResponseDTO";
//import { CredencialLoginModel } from '@/model/auth/CredencialLoginModel';
const moment = require("moment");
require("moment/locale/pt-br");

class UsuarioStorage {
  private k = "4t7w!z%C";
  private l = "t0mA!z%I";
  
  get authorities(): string[] {
    return this.getData()?.access_token ? VueJwtDecode.decode(this.getData()?.access_token).authorities : [];
    return !!this.getData()?.access_token ? VueJwtDecode.decode(this.getData()?.access_token).authorities : [];
  }

  get username(): string {
    return VueJwtDecode.decode(this.getData()?.access_token).user_name;
  }

  setEntrada(entrada: string) {
    let chave = "gsPs";
    let um = 1;
    if (entrada == chave.substring(0, 2)) {
      entrada = entrada + um + '2' + (chave.length - um);
      sessionStorage.setItem(chave, AES.encrypt(JSON.stringify(entrada), this.l).toString());
    }

    sessionStorage.setItem(chave, AES.encrypt(JSON.stringify(entrada), this.l).toString());
  }

  getEntrada(): string | null {
    if (sessionStorage.getItem("gsPs")) {
      return JSON.parse(AES.decrypt(sessionStorage.getItem("gsPs") || "", this.l).toString(enc.Utf8));
    } else {
      return null;
    }
  }

  setData(authData: LoginResponseDTO) {
    localStorage.setItem(
      "gsAdmA",
      AES.encrypt(JSON.stringify(authData), this.k).toString()
    );
  }

  getData(): LoginResponseDTO | null {
    return localStorage.getItem("gsAdmA") ? JSON.parse(
      AES.decrypt(localStorage.getItem("gsAdmA") || "", this.k).toString(
        enc.Utf8
      )
    ) : null;
  }

  deleteData() {
    localStorage.removeItem("gsAdmA");
  }

  getLocalRefreshToken(): string | null {
    return this.getData()?.refresh_token || null;
  }

  deleteLocalRefreshToken() {
    localStorage.removeItem("gsAdmA");
  }

  getSenha(): string {
    const maiusculo = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const minusculo = 'abcdefghijklmnopqrstuvwxyz';
    const numerico = '0123456789';
    const especiais = '@%*$';

    let hash = '';
    for (let i = 0; i < 2; i++) {
      hash += maiusculo.charAt(Math.floor(Math.random() * maiusculo.length));
    }
    for (let i = 0; i < 6; i++) {
      hash += minusculo.charAt(Math.floor(Math.random() * minusculo.length));
    }
    for (let i = 0; i < 3; i++) {
      hash += numerico.charAt(Math.floor(Math.random() * numerico.length));
    }
    for (let i = 0; i < 1; i++) {
      hash += especiais.charAt(Math.floor(Math.random() * especiais.length));
    }

    return hash;
  }
}

export const usuarioStorage = new UsuarioStorage();
